import RoleNameInput from './roleNameInput.container'

export default RoleNameInput;